var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "v-dialog",
    {
      attrs: {
        "content-class": _vm.dialogContentClass,
        persistent: _vm.isPersistent
      },
      model: {
        value: _vm.isOpen,
        callback: function($$v) {
          _vm.isOpen = $$v
        },
        expression: "isOpen"
      }
    },
    [
      _c(
        "v-card",
        { class: _vm.cardContainerClass, attrs: { flat: "" } },
        [
          _c("v-card-title", [
            _c("div", { class: _vm.headerClass }, [
              _vm._v(_vm._s(_vm.$t(_vm.headerText, _vm.metadata)))
            ])
          ]),
          _vm._v(" "),
          _c(
            "v-container",
            { class: _vm.bodyContainerClass },
            [
              _c(
                "v-row",
                { attrs: { "no-gutters": "" } },
                [
                  _c("v-col", { attrs: { cols: "12" } }, [
                    _c("div", {
                      class: _vm.bodyContentClass,
                      domProps: { innerHTML: _vm._s(_vm.bodyHTML) },
                      on: { click: _vm.onBodyClick }
                    })
                  ])
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "v-row",
                { attrs: { "no-gutters": "" } },
                [
                  _c("v-col", { attrs: { cols: "12" } }, [
                    _c(
                      "div",
                      {},
                      [
                        _vm.showConfirm
                          ? _c(
                              "v-btn",
                              {
                                class: _vm.confirmClass,
                                attrs: { dark: "" },
                                on: { click: _vm.onConfirmButtonClicked }
                              },
                              [
                                _vm._v(
                                  _vm._s(_vm.$t(_vm.confirmText, _vm.metadata))
                                )
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.showAltConfirm
                          ? _c(
                              "v-btn",
                              {
                                class: _vm.altConfirmClass,
                                attrs: { dark: "" },
                                on: { click: _vm.onAltConfirmButtonClicked }
                              },
                              [
                                _vm._v(
                                  _vm._s(
                                    _vm.$t(_vm.altConfirmText, _vm.metadata)
                                  )
                                )
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.showCancel
                          ? _c(
                              "v-btn",
                              {
                                class: _vm.cancelClass,
                                attrs: { text: "" },
                                on: { click: _vm.onCancelButtonClicked }
                              },
                              [
                                _vm._v(
                                  _vm._s(_vm.$t(_vm.cancelText, _vm.metadata))
                                )
                              ]
                            )
                          : _vm._e()
                      ],
                      1
                    )
                  ])
                ],
                1
              )
            ],
            1
          )
        ],
        1
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2d2a06de", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2d2a06de","hasScoped":true,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/AppConfirmationDialog.vue
// module id = y05f
// module chunks = 5